import axios from "axios";
import {
  BASE_URL,
  LOGIN,
  LOGOUT,
  FORGET_PASSWORD,
  CREATE_USER,
  UPDATE_USER,
  GET_USER_DETAILS,
  GET_USERS_LIST,
  CREATE_PUBLISHER,
  UPDATE_PUBLISHER,
  GET_PUBLISHER_DETAILS,
  GET_PUBLISHER_LIST,
  CREATE_DEAL,
  UPDATE_DEAL,
  DEAL_DETAILS,
  DEAL_LIST,
  CREATE_PRODUCT_TYPE,
  UPDATE_PRODUCT_TYPE,
  PRODUCT_LIST,
  CREATE_INSERTION_ORDER,
  UPDATE_INSERTION_ORDER,
  INSERTION_ORDER_DETAILS,
  INSERTION_ORDER_LIST,
  INSERTION_ORDER_HISTORY,
  PUBLISHER_RESET_PASSWORD,
  CREATE_TAG,
  UPDATE_TAG,
  TAG_DETAILS,
  TAG_LIST,
  DELETE_INSERTION_ORDER,
  GET_PUBLISHER_BILLING_INFO,
  UPDATE_PUBLISHER_BILLING_INFO,
  CREATE_PUBLISHER_BILLING_INFO,
  VALIDATE_URL_UUID,
  RESET_PASSWORD,
  GET_PRODUCT_TYPE_DETAILS,
  ADVERTISER_BLOCK_LIST,
  GET_ADVERTISER_BLOCK_LIST,
  DOWNLOAD_ADVERTISER_BLOCK_LIST,
  DOWNLOAD_ADS_TXT_FILE,
  ADS_FILE_UPLOAD,
  USER_RESET_PASSWORD,
  DOWNLOAD_INSERTION_ORDER,
  ADVERTIZE_LIST_FILE_UPLOAD,
  GET_ADS_LIST,
  GET_ADVERTIZE_LIST,
  DOWNLOAD_ADVERTIZE_LIST_FILE,
  DELETE_PRODUCT_TYPE,
  CREATE_MARGIN_MANAGEMENT,
  MARGIN_MANAGEMENT_LIST,
  GET_MARGIN_MANAGEMENT_DATA,
  UPDATE_MARGIN_MANAGEMENT,
  UPLOAD_REPORTING_CSV_FILE,
  GET_CSV_LOG_LIST,
  ADMIN_DASHBOARD_CHART_API,
  GET_ADMIN_REPORTING_LIST,
  GET_ADMIN_KPI_DATA,
  ADVERTISER_BLOCK_LOGS_LIST,
  ADVERTISE_LOGS_LIST,
  ADS_LOGS_LIST,
  REPORTING_PROCESS,
  GET_PUBLISHER_REPORTING_LIST,
  GET_PUBLISHER_KPI_DATA,
  GET_ADMIN_PERFORMANCE,
  EXPORT_CSV_FUNCTIONALITY,
  LOGIN_AS_PUBLISHER,
  CHANGE_PASSWORD,
  GET_DEMAND_PARTNER_LIST,
  CREATE_PUBLISHER_USER,
  LIST_PUBLISHER_USER,
  PUBLISHER_USER_DETAILS,
  BANK_DETAIL_HISTORY,
  LIST_PUBLISHER_BILLING_INFO,
  BANK_INFO_DETAILS,
  UPDATE_PUBLISHER_BILLING_INFO_STATUS,
  PUBLISHER_BILLING_STATUS,
  LEDGER_LIST,
  ADD_LEDGER_ADJUSTMENT,
  ADJUSTEMENT_DETAILS,
  ADD_PUBLISHER_ADVANCE,
  PUBLISHER_ADVANCE_LIST,
  PUBLISHER_ADVANCE_DETAILS,
  COUNTRY_LIST,
  POST_LEDGER,
  UPDATE_LEDGER_STATUS,
  PUBLISHER_LEDGER_LIST,
  POSTED_LEDGER_LIST,
  UPLOAD_INVOICE,
  LIST_INVOICES,
  GET_INVOICE_DETAILS,
  GET_ACTIVE_LEDGER_DETAILS,
  LIST_RERUN_LOGS,
  LIST_INVOICES_HISTORY,
  DOWNLOAD_INVOICE,
} from "./apiConstants";

const API = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const CsvAPI = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "csv/text",
  },
});

API.interceptors.request.use((req) => {
  if (localStorage.getItem("p")) {
    req.headers.token = JSON.parse(localStorage.getItem("p")).token;
  }
  return req;
});

CsvAPI.interceptors.request.use((req) => {
  if (localStorage.getItem("p")) {
    req.headers.token = JSON.parse(localStorage.getItem("p")).token;
  }
  return req;
});

// Login API
export const user_login = (loginData) => API.post(`${LOGIN}`, loginData);

// Logout API
export const user_logout = () => API.post(LOGOUT);

// forgot password API
export const user_forgot_password = (emailData) =>
  API.post(`${FORGET_PASSWORD}`, emailData);

// ====> User API <=====
//Create User
export const create_user = (userData) => API.post(`${CREATE_USER}`, userData);

// Update User
export const update_user = (userId, userData) =>
  API.patch(`${UPDATE_USER}/${userId}`, userData);

// User Details
export const get_user_details = (userId) =>
  API.get(`${GET_USER_DETAILS}/${userId}`);

// Users List
export const users_list = (
  pageNum,
  filters,
  searchString,
  sortField,
  sortOrder,
) =>
  API.get(`${GET_USERS_LIST}`, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
      ...(sortField
        ? {
          sortOptionJSON: JSON.stringify({
            sortBy: sortField,
            sortType: sortOrder?.toUpperCase() || "DESC",
          }),
        }
        : {}),
    },
  });

// ===> Publisher API <===
// Create Publisher
export const create_publisher = (publisherData) =>
  API.post(`${CREATE_PUBLISHER}`, publisherData);

// Update Publisher
export const update_publisher = (publisherId, publisherData) =>
  API.patch(`${UPDATE_PUBLISHER}/${publisherId}`, publisherData);

// Publisher Details
export const publisher_details = (publisherId) =>
  API.get(`${GET_PUBLISHER_DETAILS}/${publisherId}`);

// Publisher List
export const publisher_list = (
  pageNum,
  filters,
  searchString,
  sortField,
  sortOrder,
) =>
  API.get(`${GET_PUBLISHER_LIST}`, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(sortField
        ? {
          sortOptionJSON: JSON.stringify({
            sortBy: sortField,
            sortType: sortOrder?.toUpperCase() || "DESC",
          }),
        }
        : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

//Publisher Reset Password
export const publisher_reset_password = (publisherId) =>
  API.get(`${PUBLISHER_RESET_PASSWORD}/${publisherId}`);

// ===> Deal API <===
//Create Deal
export const create_deal = (dealData) => API.post(`${CREATE_DEAL}`, dealData);

//Update Deal
export const update_deal = (dealId, dealData) =>
  API.patch(`${UPDATE_DEAL}/${dealId}`, dealData);

//Deal Details
export const deal_details = (dealId) => API.get(`${DEAL_DETAILS}/${dealId}`);

// Deal List
export const deal_list = (
  pageNum,
  filters,
  searchString,
  pageSize,
  sortField,
  sortOrder,
) =>
  API.get(`${DEAL_LIST}`, {
    params: {
      page: pageNum,
      noOfRecordsPerPage: pageSize,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
      ...(sortField
        ? {
          sortOptionJSON: JSON.stringify({
            sortBy: sortField,
            sortType: sortOrder?.toUpperCase() || "DESC",
          }),
        }
        : {}),
    },
  });


// ===> Product Type API<===
//Create Product Type
export const create_product_type = (productTypeData) =>
  API.post(`${CREATE_PRODUCT_TYPE}`, productTypeData);

//Update Product Type
export const update_product_type = (productTypeId, productTypeData) =>
  API.patch(`${UPDATE_PRODUCT_TYPE}/${productTypeId}`, productTypeData);

export const get_product_type_details = (productTypeID) =>
  API.get(`${GET_PRODUCT_TYPE_DETAILS}/${productTypeID}`);

//Product Type List
export const product_type_list = (
  pageNum,
  filters,
  searchString,
  sortField,
  sortOrder,
) =>
  API.get(`${PRODUCT_LIST}`, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
      ...(sortField
        ? {
          sortOptionJSON: JSON.stringify({
            sortBy: sortField,
            sortType: sortOrder?.toUpperCase() || "DESC",
          }),
        }
        : {}),
    },
  });

// Delete Product Type
export const delete_product_type = (productTypeId) =>
  API.delete(`${DELETE_PRODUCT_TYPE}/${productTypeId}`);

// ===> Insertion Orders List <===
// Create Insertion Orders
export const create_insertion_order = (ioData) =>
  API.post(`${CREATE_INSERTION_ORDER}`, ioData, {
    headers: {
      "Content-Type": "multiType/formData",
    },
  });

// Update Insertion Orders
export const update_insertion_order = (ioId, ioData) =>
  API.patch(`${UPDATE_INSERTION_ORDER}/${ioId}`, ioData);

//Insertion Order Details
export const insertion_order_details = (ioId) =>
  API.get(`${INSERTION_ORDER_DETAILS}/${ioId}`);

//Insertion Order List
export const insertion_order_list = (
  pageNum,
  filters,
  searchString,
  sortField,
  sortOrder,
) =>
  API.get(`${INSERTION_ORDER_LIST}`, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
      ...(sortField
        ? {
          sortOptionJSON: JSON.stringify({
            sortBy: sortField,
            sortType: sortOrder?.toUpperCase() || "DESC",
          }),
        }
        : {}),
    },
  });

//Insertion Order History
export const insertion_order_history = (
  ioId,
  sortField,
  sortOrder,
  pageNum,
) =>
  API.get(`${INSERTION_ORDER_HISTORY}/${ioId}`, {
    params: {
      page: pageNum,
      ...(sortField
        ? {
          sortOptionJSON: JSON.stringify({
            sortBy: sortField,
            sortType: sortOrder?.toUpperCase() || "DESC",
          }),
        }
        : {}),
    },
  });

//Insertion Order History
export const delete_insertion_order = (ioId) =>
  API.delete(`${DELETE_INSERTION_ORDER}/${ioId}`);

export const download_insertion_order = (publisherId) =>
  API.get(`${DOWNLOAD_INSERTION_ORDER}/${publisherId}`, {
    responseType: "blob", //  REQUIRED
  });

// ==> Tag Apis
//Create Tag
export const create_tag = (tagData) => API.post(`${CREATE_TAG}`, tagData);

// Update Tag
export const update_tag = (tagID, tagData) =>
  API.patch(`${UPDATE_TAG}/${tagID}`, tagData);

// Tag Details
export const tag_details = (tagID) => API.get(`${TAG_DETAILS}/${tagID}`);

// Tag List
export const tag_list = (
  pageNum,
  filters,
  searchString,
  pageSize,
  sortField,
  sortOrder,
) =>
  API.get(`${TAG_LIST}`, {
    params: {
      page: pageNum,
      noOfRecordsPerPage: pageSize,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
      ...(sortField
        ? {
          sortOptionJSON: JSON.stringify({
            sortBy: sortField,
            sortType: sortOrder?.toUpperCase() || "DESC",
          }),
        }
        : {}),
    },
  });

// Publisher Billing Info Apis

export const create_publisher_billing_info = (billingData) =>
  API.post(`${CREATE_PUBLISHER_BILLING_INFO}`, billingData);

export const billing_info_by_publisher_id = (publisherId) =>
  API.get(`${GET_PUBLISHER_BILLING_INFO}/${publisherId}`);

export const update_billing_info_by_publisher_id = (publisherId, billingData) =>
  API.patch(`${UPDATE_PUBLISHER_BILLING_INFO}/${publisherId}`, billingData);

export const validate_url_uuid = (uuid) =>
  API.get(`${VALIDATE_URL_UUID}?id=${uuid}`);

export const reset_password = (passwordData) =>
  API.post(`${RESET_PASSWORD}`, passwordData);

//Advertiser Block List
export const advertiser_block_list = (formData) =>
  CsvAPI.post(`${ADVERTISER_BLOCK_LIST}`, formData);

//Advertiser Block List
export const get_advertiser_block_list = (publisherID) =>
  CsvAPI.get(
    `${publisherID ? GET_ADVERTISER_BLOCK_LIST + publisherID : GET_ADVERTISER_BLOCK_LIST + "0"}`,
  );

export const download_advertiser_block_list = (publisherID) =>
  CsvAPI.get(
    `${publisherID ? DOWNLOAD_ADVERTISER_BLOCK_LIST + publisherID : DOWNLOAD_ADVERTISER_BLOCK_LIST + "0"}`,
  );

export const download_ads_txt = (publisherID) =>
  CsvAPI.get(
    `${publisherID ? DOWNLOAD_ADS_TXT_FILE + publisherID : DOWNLOAD_ADS_TXT_FILE + "0"}`,
  );

//Advertiser Block List
export const upload_ads_file = (formData, publisherID) =>
  CsvAPI.post(`${ADS_FILE_UPLOAD}${publisherID}`, formData);

export const user_reset_password = (userID) =>
  API.get(`${USER_RESET_PASSWORD}/${userID}`);

//Advertiser Block List
export const upload_advertize_list_file = (formData, publisherID) =>
  CsvAPI.post(`${ADVERTIZE_LIST_FILE_UPLOAD}${publisherID}`, formData);

export const get_ads_list = (publisherID) =>
  CsvAPI.get(
    `${publisherID ? GET_ADS_LIST + publisherID : GET_ADS_LIST + "0"}`,
  );

export const get_advertize_list = (publisherID) =>
  CsvAPI.get(
    `${publisherID ? GET_ADVERTIZE_LIST + publisherID : GET_ADVERTIZE_LIST + "0"}`,
  );

export const download_advertiser_list = (publisherID) =>
  CsvAPI.get(
    `${publisherID ? DOWNLOAD_ADVERTIZE_LIST_FILE + publisherID : DOWNLOAD_ADVERTIZE_LIST_FILE + "0"}`,
  );

// Margin Management
// Cerate Margin Management
export const create_margin_management = (marginManagementData) =>
  API.post(`${CREATE_MARGIN_MANAGEMENT}`, marginManagementData);

// Update Margin Management
export const update_margin_management = (
  marginManagementId,
  marginManagementData,
) =>
  API.patch(
    `${UPDATE_MARGIN_MANAGEMENT}/${marginManagementId}`,
    marginManagementData,
  );

// Update Margin Management
export const get_margin_management_data = (marginManagementId) =>
  API.get(`${GET_MARGIN_MANAGEMENT_DATA}/${marginManagementId}`);

// Update Margin Management
export const margin_management_list = (
  pageNum,
  filters,
  searchString,
  sortField,
  sortOrder,
) =>
  API.get(`${MARGIN_MANAGEMENT_LIST}`, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
      ...(sortField
        ? {
          sortOptionJSON: JSON.stringify({
            sortBy: sortField,
            sortType: sortOrder?.toUpperCase() || "DESC",
          }),
        }
        : {}),
    },
  });

export const upload_reporting_raw_csv = (formData) =>
  CsvAPI.post(`${UPLOAD_REPORTING_CSV_FILE}`, formData);

// export const get_csv_logs_list = (
//   pageNum,
//   filters,
//   searchString,
//   sortField,
//   sortOrder,
// ) =>
//   API.get(
//     `${GET_CSV_LOG_LIST}?page=${pageNum}&${searchString ? `searchString=${searchString}&` : ""}${filters?.length ? `filtersJSON=${JSON.stringify(filters)}` : ""}`,
//   );

export const get_csv_logs_list = (
  pageNum,
  filters,
  searchString,
  sortField,
  sortOrder,
) =>
  API.get(GET_CSV_LOG_LIST, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: JSON.stringify(filters) } : {}),
      ...(sortField
        ? {
          sortOptionJSON: JSON.stringify({
            sortBy: sortField,
            sortType: sortOrder?.toUpperCase() || "DESC",
          }),
        }
        : {}),
    },
  });

// Dashboard Api
export const get_dashbaord_chart_data = (filters) => {
  return API.get(`${ADMIN_DASHBOARD_CHART_API}`, {
    params: {
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });
};

// Admin Reporting Type Api
export const get_admin_reporting_data = (
  pageNum,
  filters = {},
  searchString,
  pageSize,
  viewType,
  sortField,
  sortOrder,
) => {
  return API.get(GET_ADMIN_REPORTING_LIST, {
    params: {
      page: pageNum,
      viewType: viewType,
      noOfRecordsPerPage: pageSize,
      ...(filters.report_type ? { reportType: filters.report_type } : {}),

      ...(searchString ? { searchString } : {}),

      ...(sortField
        ? {
          sortOptionJSON: JSON.stringify({
            sortBy: sortField,
            sortType: sortOrder?.toUpperCase() || "DESC",
          }),
        }
        : {}),

      ...(Object.keys(filters).length
        ? { filtersJSON: filters.filterParams }
        : {}),
    },
  });
};

// Admin KPI Api
export const get_admin_kpi_data = (filters) =>
  API.get(`${GET_ADMIN_KPI_DATA}`, {
    params: {
      ...(Object.keys(filters).length
        ? { filtersJSON: filters.filterParams }
        : {}),
    },
  });

// Admin Performance Api
export const get_admin_performance_data = (
  pageNum,
  filters,
  pageSize,
  searchString,
  sortField,
  sortOrder
) => {

  const params = {
    page: pageNum,
    noOfRecordsPerPage: pageSize,
    ...(searchString ? { searchString } : {}),
    ...(Object.keys(filters).length ? { filtersJSON: filters.filterParams } : {}),
  };

  if (sortField && sortOrder) {
    params.sortOptionJSON = JSON.stringify({
      sortBy: sortField,
      sortType: sortOrder?.toUpperCase() || "DESC",
    });
  }
  return API.get(`${GET_ADMIN_PERFORMANCE}`, { params });
};

// Logs List API's

// export const get_advertise_logs_blocklist = (
//   pageNum,
//   filters,
//   searchString,
//   publisherId,
// ) => {
//   API.get(`${ADVERTISER_BLOCK_LOGS_LIST}/${publisherId}`, {
//     params: {
//       page: pageNum,
//       ...(searchString ? { searchString } : {}),
//       ...(filters?.length ? { filtersJSON: filters } : {}),
//     },
//   });
// };

// export const get_advertise_logs_list = (
//   pageNum,
//   filters,
//   searchString,
//   publisherId,
// ) => {
//   API.get(`${ADVERTISE_LOGS_LIST}/${publisherId}`, {
//     params: {
//       page: pageNum,
//       ...(searchString ? { searchString } : {}),
//       ...(filters?.length ? { filtersJSON: filters } : {}),
//     },
//   });
// };

// export const get_ads_logs_list = (
//   pageNum,
//   filters,
//   searchString,
//   publisherId,
// ) => {
//   API.get(`${ADS_LOGS_LIST}/${publisherId}`, {
//     params: {
//       page: pageNum,
//       ...(searchString ? { searchString } : {}),
//       ...(filters?.length ? { filtersJSON: filters } : {}),
//     },
//   });
// };

export const get_advertise_logs_blocklist = (id) =>
  API.get(`${ADVERTISER_BLOCK_LOGS_LIST}/${id}`);

export const get_advertise_logs_list = (id) =>
  API.get(`${ADVERTISE_LOGS_LIST}/${id}`);

export const get_ads_logs_list = (id) => API.get(`${ADS_LOGS_LIST}/${id}`);

export const reprocess_csv = (id) => API.post(`${REPORTING_PROCESS}/${id}`);

// Publisher Reporting Type Api
export const get_publisher_reporting = (
  pageNum,
  filters = {},
  searchString,
  pageSize,
  viewType,
  sortField,
  sortOrder,
) => {
  return API.get(GET_PUBLISHER_REPORTING_LIST, {
    params: {
      page: pageNum,
      noOfRecordsPerPage: pageSize,
      ...(filters.report_type ? { reportType: filters.report_type } : {}),

      ...(searchString ? { searchString } : {}),

      ...(viewType ? { viewType } : {}),
      ...(sortField
        ? {
          sortOptionJSON: JSON.stringify({
            sortBy: sortField,
            sortType: sortOrder?.toUpperCase() || "DESC",
          }),
        }
        : {}),

      ...(Object.keys(filters).length
        ? { filtersJSON: filters.filterParams }
        : {}),
    },
  });
};

// Publisher KPI Api
export const get_publisher_kpi_api = (filters) => {
  return API.get(GET_PUBLISHER_KPI_DATA, {
    params: {
      ...(Object.keys(filters).length
        ? { filtersJSON: filters.filterParams }
        : {}),
    },
  });
};

//Product Type List
export const product_type_list_by_publisher_id = (publisherID) =>
  API.get(`${PRODUCT_LIST}/${publisherID}`);

// Publisher Reporting Type Api
export const export_csv = (
  pageNum,
  filters = {},
  searchString,
  pageSize,
  viewType,
) => {
  return CsvAPI.get(EXPORT_CSV_FUNCTIONALITY, {
    params: {
      page: pageNum,
      noOfRecordsPerPage: pageSize,
      viewType: viewType,
      ...(filters.report_type ? { reportType: filters.report_type } : {}),

      ...(searchString ? { searchString } : {}),

      ...(Object.keys(filters).length
        ? { filtersJSON: filters.filterParams }
        : {}),
    },
  });
};

// Login API
export const user_login_as_publisher = (loginData) =>
  API.post(`${LOGIN_AS_PUBLISHER}`, loginData);

export const user_change_password = (passwordData) =>
  API.patch(`${CHANGE_PASSWORD}`, passwordData);
export const create_publisher_user = (userData) => API.post(`${CREATE_PUBLISHER_USER}`, userData);

export const publisher_users_list = (pageNum, filters, searchString, sortField, sortOrder,) =>
  API.get(`${LIST_PUBLISHER_USER}`, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
      ...(sortField
        ? {
          sortOptionJSON: JSON.stringify({
            sortBy: sortField,
            sortType: sortOrder?.toUpperCase() || "DESC",
          }),
        }
        : {}),
    },
  });

// Publisher User Details
export const get_publisher_user_details = (userId) =>
  API.get(`${PUBLISHER_USER_DETAILS}/${userId}`);


export const get_demand_partner_list = () =>
  API.get(`${GET_DEMAND_PARTNER_LIST}`);

export const bank_detail_history_list = (publisherId, filters, pageNum) =>
  API.get(`${BANK_DETAIL_HISTORY}/${publisherId}`, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    }
  });

export const list_publisher_bank_details = (filters, pageNum) =>
  API.get(`${LIST_PUBLISHER_BILLING_INFO}`, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    }
  });

export const bank_info_details = (ID) =>
  API.get(`${BANK_INFO_DETAILS}${ID}`);

export const update_billing_info_status = (publisherId, billingData) =>
  API.patch(`${UPDATE_PUBLISHER_BILLING_INFO_STATUS}/${publisherId}`, billingData);

export const publisher_billing_status = () =>
  API.get(`${PUBLISHER_BILLING_STATUS}`);

export const publisher_ledger_list = (pageNum, month, year, publisherId) =>
  API.get(`${LEDGER_LIST}`, {
    params: {
      page: pageNum,
      ...(month !== null && month !== undefined ? { month } : {}),
      ...(year !== null && year !== undefined ? { year } : {}),
      ...(publisherId ? { publisherID: publisherId } : {}),
    }
  });

export const add_ledger_adjustment = (adjustmentData) =>
  API.post(`${ADD_LEDGER_ADJUSTMENT}`, adjustmentData);

export const adjustemnt_details = (ID) =>
  API.get(`${ADJUSTEMENT_DETAILS}${ID}`);

export const add_publisher_advance = (advanceData) =>
  API.post(`${ADD_PUBLISHER_ADVANCE}`, advanceData);

export const publisher_advance_list = (pageNum, month) =>
  API.get(`${PUBLISHER_ADVANCE_LIST}`, {
    params: {
      page: pageNum,
      month: month,
    }
  });

export const publisher_advance_details = (ID) =>
  API.get(`${PUBLISHER_ADVANCE_DETAILS}${ID}`);


export const update_publisher_advance = (ID, advanceData) =>
  API.patch(`${PUBLISHER_ADVANCE_DETAILS}${ID}`, advanceData);

export const country_list = () =>
  API.get(`${COUNTRY_LIST}`);

export const post_ledger = (ledgerData) =>
  API.post(`${POST_LEDGER}`, ledgerData);

export const update_publisher_ledger = (ID, ledgerData) =>
  API.patch(`${UPDATE_LEDGER_STATUS}${ID}`, ledgerData);

export const ledger_list_for_publisher = (pageNum, month, year) =>
  API.get(`${PUBLISHER_LEDGER_LIST}`, {
    params: {
      page: pageNum,
      ...(month !== null && month !== undefined ? { month } : {}),
      ...(year !== null && year !== undefined ? { year } : {}),
    }
  });

  export const posted_publisher_ledger_list = (pageNum, month, year, publisherId) =>
      API.get(`${POSTED_LEDGER_LIST}`, {
        params: {
          page: pageNum,
          ...(month !== null && month !== undefined ? { month } : {}),
          ...(year !== null && year !== undefined ? { year } : {}),
          ...(publisherId ? { publisherID: publisherId } : {}),
        }
      });

export const upload_invoice = (invoiceData) =>
  API.post(`${UPLOAD_INVOICE}`, invoiceData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }); 

  export const list_invoices = (pageNum, month, year, filters) =>
  API.get(`${LIST_INVOICES}`, {
    params: {
      page: pageNum,
      ...(month !== null && month !== undefined ? { month } : {}),
      ...(year !== null && year !== undefined ? { year } : {}),
      ...(filters?.length ? { filtersJSON: JSON.stringify(filters) } : {}),
    }
  });


export const invoice_details = (ID) =>
  API.get(`${GET_INVOICE_DETAILS}${ID}`);

export const update_invoice_status = (ID, invoiceData) =>
  API.patch(`${GET_INVOICE_DETAILS}${ID}`, invoiceData);

export const get_active_ledger_details = ( month, year,) =>
  API.get(`${GET_ACTIVE_LEDGER_DETAILS}`,{
      params: {
      ...(month !== null && month !== undefined ? { month } : {}),
      ...(year !== null && year !== undefined ? { year } : {}),
    }
  });

  export const list_rerun_logs = (pageNum, month, year, filters) =>
  API.get(`${LIST_RERUN_LOGS}`, {
    params: {
      page: pageNum,
      ...(month !== null && month !== undefined ? { month } : {}),
      ...(year !== null && year !== undefined ? { year } : {}),
      ...(filters?.length ? { filtersJSON: JSON.stringify(filters) } : {}),
    }
  });

    export const list_invoices_history = (pageNum, month, year, filters) =>
  API.get(`${LIST_INVOICES_HISTORY}`, {
    params: {
      page: pageNum,
      ...(month !== null && month !== undefined ? { month } : {}),
      ...(year !== null && year !== undefined ? { year } : {}),
      ...(filters?.length ? { filtersJSON: JSON.stringify(filters) } : {}),
    }
  });

  export const download_invoice = (ID, ) =>
  API.get(`${DOWNLOAD_INVOICE}/${ID}`,{
     responseType: "blob", 
  });